import data from "../../.sourceflow/values.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getValues = (locale = "en") => {
  return new BaseCollection(data, locale).getItems();
};
